module.exports = __webpack_public_path__ + "static/media/backward-time.d0246d45.svg";